import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import * as yup from "yup";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import { closeModal } from "../../Redux/modalSlice";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import {
    getAllUtility,
    postNewUtility,
    reset,
} from "../../Redux/UtilityProviders/UtilitySlice";

// validate the form in utitlty

const validationSchema = yup.object({
    title: yup
        .string("Enter your title")
        .min(2, "Minimum number of letters 2")
        .required("title is required"),
    rate: yup.number("Enter your rate").required("Rate is required"),
    annual_increase_percentage: yup
        .number("Enter your Annual icrease percentage")
        .required("Annual icrease percentage is required"),
    meter_rate: yup
        .number("Enter your Meter meter rate")
        .required("Meter Rate is required"),
    rebates: yup.number("Enter your rebates").required("rebates is required"),
    discounted_rate: yup
        .number("Enter your Discounted rRate")
        .required("Discounted rate is required"),
});

const CreateUtility = () => {
    const dispatch = useDispatch();

    // get all states
    useEffect(() => {
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, []);

    const { states, isStatesloading } = useSelector((state) => state.AllStates);

    //get All States
    const AllStates = states?.data?.states;

    //----------------------//

    const formik = useFormik({
        initialValues: {
            title: "",
            rate: "",
            annual_increase_percentage: "0",
            meter_rate: "0",
            rebates: "0",
            discounted_rate: "0",
            state_id: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await dispatch(postNewUtility(values));
            await dispatch(reset(values));
        },
    });
    const { isError, isSuccess, isLodaing, massage } = useSelector(
        (state) => state.utility_providers
    );
    useEffect(() => {
        if (isSuccess && AllStates) {
            toast.success("New Utility Add");
            dispatch(closeModal());
            dispatch(getAllUtility());
            dispatch(reset());
        }
        if (isError) {
            toast.error(massage);
        }
        dispatch(reset());
    }, [isSuccess, isError, massage]);

    return (
        <>
            {isStatesloading && <LoadingAnimation />}
            {!isStatesloading && (
                <FormContainer>
                    <FormHeading>Add a New Utility </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="title"
                                    name="title"
                                    label="Title"
                                    value={formik.values.title}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.title &&
                                        Boolean(formik.errors.title)
                                    }
                                    helperText={
                                        formik.touched.title &&
                                        formik.errors.title
                                    }
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="rate"
                                    name="rate"
                                    label="Rate"
                                    type="number"
                                    value={formik.values.rate}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.rate &&
                                        Boolean(formik.errors.rate)
                                    }
                                    helperText={
                                        formik.touched.rate &&
                                        formik.errors.rate
                                    }
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="annual_increase_percentage"
                                    name="annual_increase_percentage"
                                    label="Annual Increase Percentage"
                                    type="number"
                                    value={
                                        formik.values.annual_increase_percentage
                                    }
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched
                                            .annual_increase_percentage &&
                                        Boolean(
                                            formik.errors
                                                .annual_increase_percentage
                                        )
                                    }
                                    helperText={
                                        formik.touched
                                            .annual_increase_percentage &&
                                        formik.errors.annual_increase_percentage
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="meter_rate"
                                    name="meter_rate"
                                    label="meter_rate"
                                    type="number"
                                    value={formik.values.meter_rate}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.meter_rate &&
                                        Boolean(formik.errors.meter_rate)
                                    }
                                    helperText={
                                        formik.touched.meter_rate &&
                                        formik.errors.meter_rate
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="rebates"
                                    name="rebates"
                                    label="rebates"
                                    type="number"
                                    value={formik.values.rebates}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.rebates &&
                                        Boolean(formik.errors.rebates)
                                    }
                                    helperText={
                                        formik.touched.rebates &&
                                        formik.errors.rebates
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="discounted_rate"
                                    name="discounted_rate"
                                    label="Discounted Rate"
                                    type="number"
                                    value={formik.values.discounted_rate}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.discounted_rate &&
                                        Boolean(formik.errors.discounted_rate)
                                    }
                                    helperText={
                                        formik.touched.discounted_rate &&
                                        formik.errors.discounted_rate
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={12}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        State
                                    </InputLabel>
                                    <Select
                                        id="state_id"
                                        name="state_id"
                                        label="State"
                                        required={true}
                                        value={formik.values.state_id || ""}
                                        onChange={formik.handleChange}
                                    >
                                        {AllStates?.map((key) => (
                                            <MenuItem
                                                key={key.id}
                                                value={key.id}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLodaing ? "loading ... " : " Add New Utility"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};
const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreateUtility;
